




















import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component({
  model: {
    prop: 'checked',
    event: 'change'
  }
})
export default class AtomCheckBox3 extends ComponentVue {
  @Prop({ type: String })
  name!: string

  @Prop({ type: String })
  label!: string

  @Prop({ type: [String, Number] })
  checked!: string | number

  @Prop({ type: [String, Number] })
  value!: string | number

  @Prop({ type: Boolean, default: false })
  small!: boolean

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  @Prop({ type: [String, Number] })
  trueval!: string | number

  @Prop({ type: [String, Number] })
  falseval!: string | number

  get internalValue(): string | number {
    return this.checked
  }

  set internalValue(newVal: string | number) {
    this.$emit('change', newVal)
  }
}
